module.exports = __webpack_public_path__ + "static/media/passport-example.599b64eb.jpg";